export enum ToneOption {
    FORMAL = 'formal',
    CASUAL = 'casual',
    SOCIAL = 'social',
}